import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { UserEditService } from '@services/user-edit.service';
import { UserFormBaseService } from '@services/user-form-base.service';
import { UserSubjectBaseService } from '@services/user-subject-base.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EditUserComponent } from './edit-user.component';

@Component({
  selector: 'acb-alcon-edit-user-dialog',
  template: `
    <kendo-dialog-titlebar class="acb-select-titlebar" (close)="onClose()">
      Edit User
    </kendo-dialog-titlebar>
    <ng-container #editUserContainer></ng-container>
    <kendo-dialog-actions>
      <button kendoButton class="acb-cancel" (click)="onCancel()"><span class="k-icon k-i-cancel"></span>Cancel</button>
      <button kendoButton [primary]="true" (click)="onSave()" [disabled]="!isFormValid" ><span class="k-icon k-i-checkmark"></span>Save</button>
    </kendo-dialog-actions>
  `,
  styles: [
  ],
  providers: [
    UserEditService,
    {
      provide: UserFormBaseService,
      useExisting: UserEditService
    },
    {
      provide: UserSubjectBaseService,
      useExisting: UserFormBaseService
    }
  ]
})
export class EditUserDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('editUserContainer', { read:ViewContainerRef }) editUserContainer?: ViewContainerRef;

  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();

  private _valid: boolean = true;
  public get isFormValid():boolean {
    return this._valid;
  }

  private _userEditService?: UserEditService;
  public set userEditService(value:UserEditService) {
    this._userEditService = value;
    this._userEditService.validityChange.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this._valid = x;
    })
  }

  constructor(
    private resolver: ComponentFactoryResolver,
    private changeDetectionRef : ChangeDetectorRef
  ) {
  }

  public destroy$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
  }

  public onCancel() {
    this.cancel.emit(null);
  }

  public onSave() {
    if (this.isFormValid)
      this.save.emit(null);
  }

  public onClose() {
    this.cancel.emit(null);
  }


  ngAfterViewInit(): void {

    // Need to pass service to edit details component, provider context is lost going through window service...
    // TODO: Clean up by moving to feature NGRX?
    if (this.editUserContainer && this._userEditService) {

      const factory = this.resolver.resolveComponentFactory(EditUserComponent);
      const injector: Injector = Injector.create({ providers: [
        {
          provide: UserEditService, useValue: this._userEditService
        },
        {
          provide: UserFormBaseService, useExisting: UserEditService
        }
      ]});
      injector.get(UserEditService);

      const ref: ComponentRef<EditUserComponent> =  this.editUserContainer.createComponent(factory, undefined, injector);
      ref.instance.editUserMode = 'edit';

      this.changeDetectionRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
